import React, { useState } from "react";
import { Link } from "react-router-dom";
import { apiFetch } from "../../lib/http";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [status, setStatus] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setStatus(null);
    setError(null);

    const resp = await apiFetch("/api/auth/password-reset/", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email })
    });

    if (!resp.ok) {
      const data = await resp.json().catch(() => ({}));
      setError(data?.error || "Failed to send reset email.");
      setBusy(false);
      return;
    }

    setStatus("If that email exists, a reset link has been sent.");
    setBusy(false);
  }

  return (
    <div className="min-h-screen bg-slate-950 text-slate-50 text-[15px] selection:bg-cyan-400/30 selection:text-cyan-50">
      <div className="mx-auto max-w-md min-h-screen flex flex-col">
        <main className="flex flex-1 items-center justify-center px-4 py-6">
          <section className="w-full rounded-3xl bg-slate-900/40 ring-1 ring-cyan-300/25 p-5">
            <header className="flex items-center justify-center gap-3 text-center">
              <img src="/static/img/site-logo.png" alt="" className="h-16 w-16 object-contain" />
              <div className="min-w-0">
                <div
                  className="text-2xl font-semibold tracking-tight"
                  style={{
                    textShadow:
                      "0 0 14px rgba(6,182,212,0.48), 0 0 22px rgba(217,70,239,0.34)",
                    filter: "drop-shadow(0 0 8px rgba(255,255,255,0.28))"
                  }}
                >
                  <span className="text-cyan-200">Human</span>{" "}
                  <span className="text-fuchsia-200">Jukebox</span>
                </div>
              </div>
            </header>

            <div className="mt-3 text-center text-sm text-slate-300">Reset your password</div>

            {status ? (
              <div className="mt-4 rounded-2xl bg-emerald-500/15 ring-1 ring-emerald-300/25 px-4 py-3 text-sm text-emerald-50">
                {status}
              </div>
            ) : null}
            {error ? (
              <div className="mt-4 rounded-2xl bg-rose-500/15 ring-1 ring-rose-300/25 px-4 py-3 text-sm text-rose-50">
                {error}
              </div>
            ) : null}

            <form onSubmit={onSubmit} className="mt-4 space-y-3">
              <label className="block">
                <div className="text-sm text-slate-200">Email</div>
                <div className="mt-1 relative">
                  <input
                    className="w-full rounded-2xl bg-slate-950/40 ring-1 ring-white/10 px-4 py-3 pr-12 text-base text-slate-50 outline-none focus:ring-2 focus:ring-cyan-300/40"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    placeholder="you@example.com"
                  />
                  <i className="fa-regular fa-envelope absolute right-4 top-1/2 -translate-y-1/2 text-slate-300" />
                </div>
              </label>
              <button
                className="mt-2 w-full rounded-2xl bg-cyan-500/20 hover:bg-cyan-500/25 ring-1 ring-cyan-300/30 px-4 py-3 text-sm font-semibold text-cyan-50 disabled:opacity-60"
                type="submit"
                disabled={busy}
              >
                {busy ? "…" : "Send reset link"}
              </button>
              <div className="pt-2 text-center text-sm text-slate-300">
                <Link className="text-fuchsia-100 underline decoration-fuchsia-300/30 underline-offset-4" to="/login">
                  Back to login
                </Link>
              </div>
            </form>
          </section>
        </main>
      </div>
    </div>
  );
}

